import { ApiClient, ApiOrg, client, MessagesClient } from "lib/api";
import { JwtUser } from "utils";

export interface State {
  isAuthenticated: boolean;
  user: JwtUser | null;
  apiClient: ApiClient;
  org: ApiOrg | null;
  messages: MessagesClient | null;
}

export const initialState: State = {
  isAuthenticated: false,
  user: null,
  apiClient: client,
  org: null,
  messages: null,
};
